import { ComponentProps } from "react"
import { ChBetterDocSearchDialog } from "@/modules/patients/detail/better-doc/ch/ch-better-doc-search-dialog"
import { DeBetterDocSearchDialog } from "@/modules/patients/detail/better-doc/de/de-better-doc-search-dialog"
import type { DeBetterDocInsurance } from "@/modules/patients/detail/better-doc/types"
import { useCountryParam } from "@/modules/patients/hooks/useCountryParam"

type BetterDocSearchDialogProps = ComponentProps<typeof ChBetterDocSearchDialog> & {
  deBetterDocInsurance: DeBetterDocInsurance | null
}

export const BetterDocSearchDialog = ({ deBetterDocInsurance, ...props }: BetterDocSearchDialogProps) => {
  const country = useCountryParam()

  if (country === "CH") {
    return <ChBetterDocSearchDialog {...props} />
  }

  if (country === "DE") {
    return (
      <DeBetterDocSearchDialog
        onClose={props.onClose}
        specialtyName={props.specialtyName}
        pointOfCareSpecialtyId={props.pointOfCareSpecialtyId}
        isBetterDocSpecialtyFixed={props.isBetterDocSpecialtyFixed}
        effectivePointOfCare={props.effectivePointOfCare}
        episodeOfCareProgressNoteData={props.episodeOfCareProgressNoteData}
        address={props.address}
        phoneNumber={props.phoneNumber}
        deBetterDocInsurance={deBetterDocInsurance}
      />
    )
  }

  return null
}
